import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { clientApi } from "@/api/clientApi";

export const fetchClients = createAsyncThunk("clients/fetchAll", () =>
  clientApi.list(),
);
export const createClient = createAsyncThunk(
  "clients/create",
  (data: {
    name: string;
    description?: string;
    country: string;
    currency: string;
  }) => clientApi.create(data),
);
export const deleteClient = createAsyncThunk("clients/delete", (id: string) =>
  clientApi.remove(id).then(() => id),
);

const clientSlice = createSlice({
  name: "clients",
  initialState: { list: [] as any[], loading: false },
  reducers: {},
  extraReducers: (b) => {
    b.addCase(fetchClients.pending, (s) => {
      s.loading = true;
    })
      .addCase(fetchClients.fulfilled, (s, a) => {
        s.list = a.payload;
        s.loading = false;
      })
      .addCase(fetchClients.rejected, (s) => {
        s.loading = false;
      })
      .addCase(createClient.fulfilled, (s, a) => {
        s.list.push(a.payload);
      })
      .addCase(deleteClient.fulfilled, (s, a) => {
        s.list = s.list.filter((c: any) => c.id !== a.payload);
      });
  },
});

export default clientSlice.reducer;
